import { z } from 'zod'

export const supportSchema = z.object({
  message: z
    .string()
    .min(10, 'Please provide at least 10 characters so we can help you.')
    .max(2000, 'Message must be 2000 characters or less')
    .transform(val => val.trim()),
})

export type SupportFormInput = z.input<typeof supportSchema>
export type SupportFormData = z.infer<typeof supportSchema>
